import FinancialMapReport from './report/FinancialMapReport.vue'
import WasteBillingReport from './report/WasteBillingReport.vue'
import { GlobalController } from 'src/shared/global/GlobalController'
import BillingOrderAuditReport from './report/BillingOrderAuditReport.vue'

const ifAuthenticated = (to, from, next) => {
  GlobalController.getAsyncInstance().then(data => {
    if (data && data.authResp && data.authResp.token) {
      next()
    } else {
      next('/')
    }
  })
}

export const routes = [
  ...require('./generateOrder/router').routes,
  ...require('./billingOrderAction/router').routes,
  ...require('./billingOrder/router').routes,
  {
    path: 'financial-map-report',
    name: 'financialMapReport',
    component: FinancialMapReport,
    beforeEnter: ifAuthenticated,
    props: true
  },
  {
    path: 'waste-billing-report',
    name: 'wasteBillingReport',
    component: WasteBillingReport,
    beforeEnter: ifAuthenticated,
    props: true
  },
  {
    path: 'billing-order-audit-report',
    name: 'billingOrderAuditReport',
    component: BillingOrderAuditReport,
    beforeEnter: ifAuthenticated,
    props: true
  }
]
